module.exports = __webpack_public_path__ + "static/media/background.a429cab9.png";